/** Product qty rules: `form[data-product-form]` or `div[data-product-qty-cart-line]` + `script[data-product-qty-rules]`. Binds on DOMContentLoaded / shopify:section:load. */
(function () {
  var productQtyHandlersByForm = new WeakMap();
  var easifyDelegatedChangeBound = false;
  var cartCheckoutSubmitDelegatorBound = false;

  function bindCartCheckoutSubmitDelegator() {
    if (cartCheckoutSubmitDelegatorBound) return;
    cartCheckoutSubmitDelegatorBound = true;
    document.addEventListener(
      'submit',
      function (e) {
        var f = e.target;
        if (!f || !f.matches || !f.matches('form')) return;
        if (f.getAttribute('data-product-qty-cart-submit-bound') !== '1') return;
        var lines = f.querySelectorAll('div[data-product-qty-cart-line][data-product-qty-bound="1"]');
        for (var i = 0; i < lines.length; i++) {
          var h = productQtyHandlersByForm.get(lines[i]);
          if (h && typeof h.validateSubmit === 'function' && !h.validateSubmit()) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
        }
      },
      true
    );
  }

  function syncQuantitySelectorMinusWrapper(host, input, floorMin) {
    if (!host || !input) return;
    var wrap =
      host.querySelector('[data-button-wrapper-minus]') ||
      host.querySelector('.quantity-selector__button-wrapper--minus');
    if (!wrap) return;
    var minEff = floorMin > 0 ? floorMin : 1;
    var q = input.valueAsNumber;
    if (!Number.isFinite(q) || q < 1) {
      q = parseInt(String(input.value || '').trim(), 10);
      if (!Number.isFinite(q) || q < 1) q = 1;
    }
    if (q === minEff) wrap.classList.add('quantity-selector__button-wrapper--disabled');
    else wrap.classList.remove('quantity-selector__button-wrapper--disabled');
  }

  function bindEasifyDelegatedDocumentChange() {
    if (easifyDelegatedChangeBound) return;
    easifyDelegatedChangeBound = true;
    document.addEventListener(
      'change',
      function (ev) {
        var t = ev.target;
        if (!t || !t.matches) return;
        if (!t.matches('input[type="checkbox"], input[type="radio"], select, input.tpo_option-dropdown')) return;
        var f = t.form;
        if (!f && t.getAttribute && t.getAttribute('form')) {
          try {
            f = document.getElementById(t.getAttribute('form'));
          } catch (e) {
            f = null;
          }
        }
        if (!f || f.getAttribute('data-product-qty-bound') !== '1') return;
        if (!t.closest('.easify-product-options, .tpo_option-label, [class*="tpo_option"], [class*="tpo_"]'))
          return;
        if (f.getAttribute('data-product-qty-internal') === '1') return;
        var h = productQtyHandlersByForm.get(f);
        if (h && typeof h.evaluate === 'function') {
          requestAnimationFrame(function () {
            h.evaluate();
          });
        }
      },
      true
    );
  }

  function toInt(val, fallback) {
    var n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function scheduleAddonMergeRerender() {
    try {
      if (typeof window.__cartAddonMergeSchedule === 'function') {
        window.__cartAddonMergeSchedule();
        window.setTimeout(window.__cartAddonMergeSchedule, 500);
      }
    } catch (e) {}
  }

  function updateQtyWithin(container, variantId, clampValue) {
    if (!container || !variantId) return;

    var metaEl = container.querySelector('#v' + variantId) || document.getElementById('v' + variantId);
    if (!metaEl) return;

    var minQty = toInt(metaEl.getAttribute('data-min-qty'), 1);
    var incQty = toInt(metaEl.getAttribute('data-inc-qty'), 1);

    var qtyInput = container.querySelector('[data-quantity-selector] [data-quantity-input]');
    if (!qtyInput) return;

    var formMerge = qtyInput.closest('[data-product-form]');
    if (formMerge) {
      var floor = toInt(formMerge.getAttribute('data-product-qty-floor'), 0);
      if (floor > minQty) minQty = floor;
      var stepFloor = toInt(formMerge.getAttribute('data-product-qty-step'), 0);
      if (stepFloor > incQty) incQty = stepFloor;
    }

    qtyInput.min = String(minQty);
    qtyInput.step = String(incQty);
    qtyInput.setAttribute('data-increment-value', String(incQty));
    qtyInput.dataset.incrementValue = String(incQty);

    var current = qtyInput.valueAsNumber;
    if (clampValue !== false && (!Number.isFinite(current) || current < minQty)) {
      qtyInput.value = String(minQty);
    }

    var qtyField = qtyInput.closest('[data-quantity-selector]');
    if (qtyField && qtyField.__quantitySelector) {
      qtyField.__quantitySelector.incrementValue = incQty;
      if (typeof qtyField.__quantitySelector._updateMinusButton === 'function') {
        qtyField.__quantitySelector._updateMinusButton();
      }
    }
    syncQuantitySelectorMinusWrapper(qtyField, qtyInput, minQty);

    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncThemeQty(form, vidOpt, getVidFn, clampValue) {
    var vidStr =
      vidOpt != null && vidOpt !== '' && String(vidOpt) !== 'null'
        ? String(vidOpt)
        : getVidFn();
    var vidN = parseInt(String(vidStr || ''), 10);
    if (!Number.isFinite(vidN)) return;
    var vsEl = form.querySelector('variant-selection[data-variant-selection]');
    var container =
      (vsEl &&
        (vsEl.closest('[data-section-id]') ||
          vsEl.closest('[data-product-form]') ||
          vsEl.closest('section'))) ||
      form;
    updateQtyWithin(container, vidN, clampValue);
  }

  function tryBindForm(form) {
    if (!form || form.getAttribute('data-product-qty-bound') === '1') return;
    var script = form.querySelector('script[type="application/json"][data-product-qty-rules]');
    if (!script) return;
    var cfg;
    try {
      cfg = JSON.parse(script.textContent || '{}');
    } catch (e) {
      return;
    }
    bindProductQtyForm(form, cfg);
  }

  function scanAndBind(root) {
    var forms;
    if (!root || root.nodeType === 9) {
      forms = Array.prototype.slice.call(document.querySelectorAll('form[data-product-form]'));
      Array.prototype.push.apply(forms, document.querySelectorAll('div[data-product-qty-cart-line]'));
    } else if (
      root.matches &&
      (root.matches('form[data-product-form]') || root.matches('div[data-product-qty-cart-line]'))
    ) {
      forms = [root];
    } else {
      forms = Array.prototype.slice.call(root.querySelectorAll('form[data-product-form]'));
      Array.prototype.push.apply(forms, root.querySelectorAll('div[data-product-qty-cart-line]'));
    }
    for (var i = 0; i < forms.length; i++) {
      tryBindForm(forms[i]);
    }
  }

  function bindProductQtyForm(form, cfg) {
    if (!form || form.getAttribute('data-product-qty-bound') === '1') return;
    form.setAttribute('data-product-qty-bound', '1');

    if (form.matches && form.matches('div[data-product-qty-cart-line]')) {
      var cartParentForm = form.closest('form');
      if (cartParentForm) {
        cartParentForm.setAttribute('data-product-qty-cart-submit-bound', '1');
        bindCartCheckoutSubmitDelegator();
      }
    }

    var imprint = cfg.imprint && cfg.imprint.min > 0 ? cfg.imprint : null;
    var isCartLineRoot = !!(form.matches && form.matches('div[data-product-qty-cart-line]'));
    var cartQtyDebounceMs = 140;
    var cartQtyDebounceTimer = null;

    function clearCartQtyDebounce() {
      if (cartQtyDebounceTimer) {
        clearTimeout(cartQtyDebounceTimer);
        cartQtyDebounceTimer = null;
      }
    }

    function scheduleCartLineEvaluate() {
      clearCartQtyDebounce();
      cartQtyDebounceTimer = setTimeout(function () {
        cartQtyDebounceTimer = null;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            evaluate();
          });
        });
      }, cartQtyDebounceMs);
    }

    function getQtyInput() {
      var q = form.querySelector('input[name="quantity"][data-quantity-input]');
      if (q) return q;
      if (form.matches && form.matches('div[data-product-qty-cart-line]')) {
        return form.querySelector('input[data-quantity-input]');
      }
      return null;
    }

    function getCurrentVariantId() {
      if (form.matches && form.matches('div[data-product-qty-cart-line]')) {
        var cid = form.getAttribute('data-cart-variant-id');
        return cid != null && String(cid) !== '' ? String(cid) : null;
      }
      var vs = form.querySelector('variant-selection[data-variant-selection]');
      if (vs) {
        var av = vs.getAttribute('variant');
        if (av && av !== 'not-selected') return String(av);
      }
      var main = form.querySelector('select[name="id"][data-variants], input[name="id"][data-variants]');
      if (main && main.value && main.value !== 'not-selected') return String(main.value);
      if (cfg.initialVariantId != null) return String(cfg.initialVariantId);
      return null;
    }

    function parseInt0(v) {
      var n = typeof v === 'number' ? v : parseInt(String(v || '').trim(), 10);
      return Number.isFinite(n) ? n : 0;
    }

    function variantRule(vid) {
      if (!vid) return { min: 0, inc: 0 };
      var vm = cfg.variantRules || {};
      var row = vm[vid] || vm[String(vid)] || {};
      return { min: parseInt0(row.min), inc: parseInt0(row.inc) };
    }

    function activeMinimum(vid) {
      var vr = variantRule(vid);
      if (vr.min > 0) return vr.min;
      return parseInt0(cfg.productMinQty) > 0 ? parseInt0(cfg.productMinQty) : 0;
    }

    function activeMinimumIgnoringVariant(vid) {
      return parseInt0(cfg.productMinQty) > 0 ? parseInt0(cfg.productMinQty) : 0;
    }

    function activeIncrement(vid) {
      var vr = variantRule(vid);
      if (vr.inc > 1) return vr.inc;
      var pi = parseInt0(cfg.productIncQty);
      return pi > 1 ? pi : 1;
    }

    function snapQuantityUp(q, min, inc) {
      var out = q;
      if (min > 0 && out < min) out = min;
      if (inc <= 1) return out;
      if (min > 0) {
        if ((out - min) % inc === 0) return out;
        return min + Math.ceil((out - min) / inc) * inc;
      }
      if (out % inc === 0) return out;
      return Math.ceil(out / inc) * inc;
    }

    function readCartLastValidQty() {
      var n = parseInt(String(form.getAttribute('data-product-qty-last-valid') || '').trim(), 10);
      return Number.isFinite(n) && n > 0 ? n : NaN;
    }

    /**
     * Cart: theme +/- moves by 1 while min/inc use a coarser grid. Off-grid values need direction:
     * 274 after minus → floor → 250; 276 after plus → ceil → 300. `lastValid` is the last on-grid qty.
     */
    function snapQuantityCartDirected(q, min, inc, lastValid, action) {
      if (!Number.isFinite(q) || q < 1) q = 1;
      if (min > 0 && q < min) return min;
      if (inc <= 1) return q;
      var rel = q - min;
      if (rel < 0) return min;
      if (rel % inc === 0) return q;

      // If we know direction (user clicked + / -), respect it.
      if (action === 'inc') return min + Math.ceil(rel / inc) * inc;
      if (action === 'dec') return min + Math.floor(rel / inc) * inc;

      // Without explicit direction (e.g. late DOM hydration / server-rendered off-grid values),
      // prefer snapping *up* to avoid surprising large decrements.
      return snapQuantityUp(q, min, inc);
    }

    function isPurchaseQtyValid(q, min, inc) {
      if (min > 0 && q < min) return false;
      if (inc <= 1) return true;
      if (min > 0) return (q - min) % inc === 0;
      return q % inc === 0;
    }

    function normalize(s) {
      return String(s || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function imprintVariantTitle(vid) {
      if (!imprint || !imprint.variants) return '';
      for (var i = 0; i < imprint.variants.length; i++) {
        if (String(imprint.variants[i].id) === String(vid)) return String(imprint.variants[i].title || '');
      }
      return '';
    }

    function decodeOptionName(raw) {
      var s = String(raw || '');
      try {
        s = decodeURIComponent(s.replace(/\+/g, ' '));
      } catch (e) {}
      return normalize(s);
    }

    function readImprintChoiceFromVariantOptions() {
      var variantRadios = form.querySelectorAll(
        '[data-variant-option] input[type="radio"]:checked, .options-selection__option-values input[type="radio"]:checked'
      );
      for (var j = 0; j < variantRadios.length; j++) {
        var r = variantRadios[j];
        var nameDec = decodeOptionName(r.getAttribute('name'));
        if (nameDec.indexOf('imprint') === -1) continue;
        return normalize(r.value || '');
      }

      var chosen = form.querySelectorAll('[data-variant-option-chosen-value]');
      for (var i = 0; i < chosen.length; i++) {
        var el = chosen[i];
        var fs = el.closest('fieldset');
        if (!fs) continue;
        var leg = fs.querySelector('.options-selection__option-name, legend span, legend');
        var labelText = normalize(leg ? leg.textContent : '');
        if (labelText.indexOf('imprint') === -1) continue;
        var v = normalize(el.getAttribute('data-variant-option-chosen-value'));
        if (v && v !== 'false') return v;
      }

      return '';
    }

    function isVariantImprintSelected(vid) {
      if (!imprint || !imprint.scenarioA || !vid) return false;
      var picked = readImprintChoiceFromVariantOptions();
      var t = picked ? picked : normalize(imprintVariantTitle(vid));
      if (
        t.indexOf("don't need an imprint") !== -1 ||
        /no imprint|without imprint|do not want|don't want/i.test(t)
      )
        return false;
      if (t.indexOf('imprint') === -1) return false;
      var phrases = Array.isArray(imprint.positivePhrases) ? imprint.positivePhrases : [];
      for (var i = 0; i < phrases.length; i++) {
        if (t.indexOf(normalize(phrases[i])) !== -1) return true;
      }
      return /\byes\b/i.test(t);
    }

    function easifyImprintMatchPhrases() {
      var seen = {};
      var out = [];
      function add(p) {
        var x = normalize(p);
        if (!x || seen[x]) return;
        seen[x] = 1;
        out.push(x);
      }
      var fromCfg = imprint && imprint.easifyMatchPhrases;
      if (Array.isArray(fromCfg)) {
        for (var fi = 0; fi < fromCfg.length; fi++) add(fromCfg[fi]);
      }
      if (imprint && imprint.easifyLabel) add(imprint.easifyLabel);
      add('choose your imprint type');
      add('add an imprint?');
      add('add an imprint');
      return out;
    }

    function isInsideEasifyOrTpo(el) {
      if (!el || !el.closest) return false;
      return !!el.closest(
        '.easify-product-options, .tpo_option-label, [class*="tpo_option"], [class^="tpo_"], [class*=" tpo_"]'
      );
    }

    function findEasifyGroupByPhrases(root, phrases) {
      if (!root || !phrases || !phrases.length) return null;
      var candidates = root.querySelectorAll(
        'label, legend, h3, h4, h5, dt, .option-title, [class*="option-label"], [class*="easify"], .tpo_option-label'
      );
      var pi, i, el, t, phrase;
      for (pi = 0; pi < phrases.length; pi++) {
        phrase = normalize(phrases[pi]);
        if (!phrase) continue;
        for (i = 0; i < candidates.length; i++) {
          el = candidates[i];
          if (root === form && !isInsideEasifyOrTpo(el)) continue;
          t = normalize(el.textContent || '');
          if (t === phrase || t.indexOf(phrase) !== -1) {
            return (
              el.closest('.tpo_option-label') ||
              el.closest('fieldset') ||
              el.closest('[data-easify-option]') ||
              el.closest('.easify-option') ||
              el.parentElement
            );
          }
        }
      }
      return null;
    }

    function imprintLikeTpoSwitchBlock(root) {
      if (!root || !root.querySelectorAll) return null;
      var blocks = root.querySelectorAll('.tpo_option-label');
      var bi, block, txt, sw;
      for (bi = 0; bi < blocks.length; bi++) {
        block = blocks[bi];
        txt = normalize(block.textContent || '').slice(0, 400);
        if (txt.indexOf('imprint') === -1) continue;
        if (/don't\s+(need|want)|no\s+imprint|without\s+imprint|do not want|dont want/i.test(txt)) continue;
        sw = block.querySelector(
          '.tpo_switch input[type="checkbox"], .tpo_switch input.checkbox, .tpo_switch-container input[type="checkbox"], .tpo_switch-container input.checkbox'
        );
        if (sw) return { input: sw };
      }
      return null;
    }

    function labelForInput(id, root) {
      if (!id || !root) return null;
      var labels = root.querySelectorAll('label[for]');
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].htmlFor === id) return labels[i];
      }
      return null;
    }

    function selectedValueInGroup(group) {
      if (!group) return '';
      var sel = group.querySelector('select');
      if (sel && sel.options && sel.selectedIndex >= 0) {
        var opt = sel.options[sel.selectedIndex];
        return normalize(opt ? opt.textContent : '');
      }
      var r = group.querySelector('input[type="radio"]:checked');
      if (r) {
        var lbl = (r.id && labelForInput(r.id, group)) || r.closest('label');
        if (lbl) return normalize(lbl.textContent || '');
        return normalize(r.value || '');
      }
      var swIn = group.querySelector(
        '.tpo_switch input[type="checkbox"], .tpo_switch input.checkbox, .tpo_switch-container input[type="checkbox"], .tpo_switch-container input.checkbox'
      );
      if (swIn) {
        return swIn.checked ? normalize(swIn.value || 'yes') : '';
      }
      var chk = group.querySelector('input[type="checkbox"]:checked');
      if (chk) {
        var l2 = (chk.id && labelForInput(chk.id, group)) || chk.closest('label');
        if (l2) return normalize(l2.textContent || '');
      }
      return '';
    }

    function isNoImprintChoice(text) {
      if (!text) return true;
      return /^(no|none|n\/a|—|-|–)\b|no imprint|without imprint|do not want|don't want|please select/i.test(
        text
      );
    }

    function readEasifyTpo(root) {
      var scopes = [];
      if (root && root.querySelector) scopes.push(root);
      if (form && scopes.indexOf(form) === -1) scopes.push(form);
      var si;
      for (si = 0; si < scopes.length; si++) {
        var sc = scopes[si];
        var inp = sc.querySelector(
          'input[name="properties[Choose Your Imprint Type]"], input.tpo_option-dropdown[aria-label="Choose Your Imprint Type"]'
        );
        if (inp) return normalize((inp.value || '').trim());
      }
      return '';
    }

    function readEasifyImprintHiddenProperty() {
      var sel =
        'input[type="checkbox"][name="properties[Add an imprint?]"], input[type="checkbox"][name="properties[add an imprint?]"]';
      var el = form.querySelector(sel);
      if (!el) return null;
      return !!el.checked;
    }

    function easifyImprintSearchRoots() {
      var list = [];
      var seen = {};
      function add(node) {
        if (!node || seen[node]) return;
        seen[node] = 1;
        list.push(node);
      }
      var ep = form.querySelector('.easify-product-options');
      add(ep);
      var labels = form.querySelectorAll('.tpo_option-label');
      var li;
      for (li = 0; li < labels.length; li++) add(labels[li]);
      return list;
    }

    function isEasifyImprintSelected() {
      if (!imprint || imprint.scenarioA) return false;
      var phrases = easifyImprintMatchPhrases();
      var roots = easifyImprintSearchRoots();
      var r;
      for (r = 0; r < roots.length; r++) {
        var root = roots[r];
        if (!root) continue;
        var tpo = readEasifyTpo(root);
        if (tpo) {
          if (isNoImprintChoice(tpo)) return false;
          return true;
        }
        var grp = findEasifyGroupByPhrases(root, phrases);
        if (grp) {
          var sw = grp.querySelector(
            '.tpo_switch input[type="checkbox"], .tpo_switch input.checkbox, .tpo_switch-container input[type="checkbox"], .tpo_switch-container input.checkbox'
          );
          if (sw) return !!sw.checked;
          var val = selectedValueInGroup(grp);
          if (val) {
            if (isNoImprintChoice(val)) return false;
            return true;
          }
        }
        var il = imprintLikeTpoSwitchBlock(root);
        if (il && il.input) return !!il.input.checked;
      }
      if (readEasifyImprintHiddenProperty() === true) return true;
      return false;
    }

    function isImprintSelected(vidOpt) {
      if (!imprint) return false;
      if (form.matches && form.matches('div[data-product-qty-cart-line]') && typeof cfg.cartImprintOn === 'boolean') {
        return !!cfg.cartImprintOn;
      }
      var vid =
        vidOpt != null && vidOpt !== '' && String(vidOpt) !== 'null'
          ? String(vidOpt)
          : getCurrentVariantId();
      if (imprint.scenarioA) return isVariantImprintSelected(vid);
      return isEasifyImprintSelected();
    }

    function purchaseRules(vidOpt) {
      var vid =
        vidOpt != null && vidOpt !== '' && String(vidOpt) !== 'null'
          ? String(vidOpt)
          : getCurrentVariantId();
      var inc = activeIncrement(vid);
      var impOn = !!(imprint && isImprintSelected(vid));
      var baseMin = activeMinimum(vid);
      if (
        impOn &&
        imprint &&
        imprint.scenarioA &&
        baseMin === imprint.min &&
        activeMinimumIgnoringVariant(vid) !== imprint.min
      ) {
        baseMin = activeMinimumIgnoringVariant(vid);
      }
      var min = impOn && imprint ? Math.max(baseMin, imprint.min) : baseMin;
      return { min: min, inc: inc };
    }

    function placeMessages() {
      var atc = form.querySelector('.product-form--atc');
      var wrap = form.querySelector('[data-product-qty-messages]');
      if (!atc || !wrap || wrap.parentNode === atc) return;
      atc.insertBefore(wrap, atc.firstChild);
    }

    function getMessageEls() {
      var wrap = form.querySelector('[data-product-qty-messages]');
      if (!wrap) return { err: null };
      return { err: wrap.querySelector('[data-product-qty-rule-error]') };
    }

    function readQty(input) {
      var v = input.valueAsNumber;
      if (Number.isFinite(v) && v >= 1) return Math.floor(v);
      var n = parseInt(String(input.value || '').trim(), 10);
      return Number.isFinite(n) && n >= 1 ? n : 1;
    }

    function publishFloorOnForm(pr) {
      form.setAttribute('data-product-qty-floor', pr.min > 0 ? String(pr.min) : '0');
      form.setAttribute('data-product-qty-step', pr.inc > 1 ? String(pr.inc) : '0');
    }

    function syncNativeQtyConstraints(input, pr) {
      if (!input) return;
      publishFloorOnForm(pr);
      var minAttr = pr.min > 0 ? pr.min : 1;
      var stepAttr = pr.inc > 1 ? pr.inc : 1;
      var minStr = String(minAttr);
      var stepStr = String(stepAttr);

      input.min = minStr;
      input.step = stepStr;
      input.setAttribute('data-min-value', minStr);
      input.setAttribute('data-increment-value', stepStr);

      var host = input.closest('[data-quantity-selector]');
      if (host) {
        host.setAttribute('data-min-value', minStr);
        host.setAttribute('data-increment-value', stepStr);
        if (host.tagName === 'QUANTITY-SELECTOR') {
          host.minValue = minAttr;
        }
        if (host.__quantitySelector) {
          host.__quantitySelector.incrementValue = stepAttr;
          if (typeof host.__quantitySelector._updateMinusButton === 'function') {
            host.__quantitySelector._updateMinusButton();
          }
        }
        syncQuantitySelectorMinusWrapper(host, input, minAttr);
      }
    }

    function applyQty(input, next) {
      form.setAttribute('data-product-qty-internal', '1');
      try {
        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        form.removeAttribute('data-product-qty-internal');
      }
    }

    function cartUpdateJsUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.slice(-1) !== '/') root += '/';
      return root + 'cart/update.js';
    }

    function toArrayMaybeJson(val) {
      if (Array.isArray(val)) return val;
      if (typeof val !== 'string') return [];
      var trimmed = val.trim();
      if (!trimmed) return [];
      try {
        var parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    async function updateCartLineAndAddons(lineKey, quantity) {
      if (!lineKey || !Number.isFinite(quantity) || quantity < 0) return false;

      var res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return false;
      var cart = await res.json();
      var items = (cart && cart.items) || [];
      var main = null;
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].key || '') === String(lineKey)) {
          main = items[i];
          break;
        }
      }
      if (!main) return false;

      var updates = {};
      updates[String(lineKey)] = quantity;

      var keys = main.properties ? toArrayMaybeJson(main.properties._tpo_add_on_keys) : [];
      var addonKeys = {};
      for (var k = 0; k < keys.length; k++) {
        var ak = String(keys[k] || '').trim();
        if (ak) addonKeys[ak] = true;
      }

      for (var j = 0; j < items.length; j++) {
        var it = items[j];
        var props = it && it.properties ? it.properties : null;
        var itemAddonKey = props ? String(props._tpo_add_on_key || '').trim() : '';
        if (itemAddonKey && addonKeys[itemAddonKey] && it.key) {
          updates[String(it.key)] = quantity;
        }
      }

      var updateRes = await fetch(cartUpdateJsUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
      return updateRes.ok;
    }

    function setCartQtyLoading(isLoading) {
      form.setAttribute('data-product-qty-cart-updating', isLoading ? '1' : '0');
      var buttons = form.querySelectorAll('[data-quantity-plus], [data-quantity-minus]');
      for (var i = 0; i < buttons.length; i++) buttons[i].disabled = !!isLoading;
    }

    async function handleCartQtyButton(btn, action) {
      if (!isCartLineRoot || form.getAttribute('data-product-qty-cart-updating') === '1') return;
      var input = getQtyInput();
      if (!input) return;

      var vid = getCurrentVariantId();
      var pr = purchaseRules(vid);
      var q = readQty(input);
      var step = pr.inc > 1 ? pr.inc : 1;
      var target = action === 'inc' ? q + step : q - step;
      var next = snapQuantityCartDirected(target, pr.min, pr.inc, q, action);
      if (pr.min > 0 && action === 'dec' && q <= pr.min) {
        showQtyRuleError(pr, q);
        return;
      }
      if (next === q) return;

      var row = form.closest && form.closest('li[data-cartitem-key]');
      var lineKey = row ? row.getAttribute('data-cartitem-key') : '';
      if (!lineKey) return;

      form.setAttribute('data-product-qty-last-valid', String(next));
      form.setAttribute('data-product-qty-last-action', action);
      applyQty(input, next);
      setCartQtyLoading(true);

      try {
        var ok = await updateCartLineAndAddons(lineKey, next);
        if (ok) {
          window.location.reload();
          return;
        }
      } catch (e) {}

      setCartQtyLoading(false);
      scheduleAddonMergeRerender();
    }

    function finishSyncAfterQty(input, vid, clampThemeValue) {
      var msgs = getMessageEls();
      if (msgs.err) {
        msgs.err.hidden = true;
        msgs.err.textContent = '';
      }
      var pr = purchaseRules(vid);
      syncNativeQtyConstraints(input, pr);
      syncThemeQty(form, vid, getCurrentVariantId, clampThemeValue);
      requestAnimationFrame(function () {
        var inp = getQtyInput();
        if (!inp) return;
        var v2 = getCurrentVariantId();
        var pr2 = purchaseRules(v2);
        syncNativeQtyConstraints(inp, pr2);
        syncThemeQty(form, v2, getCurrentVariantId, clampThemeValue);
      });
    }

    function evaluate() {
      if (form.getAttribute('data-product-qty-evaluating') === '1') return;
      if (isCartLineRoot) clearCartQtyDebounce();
      form.setAttribute('data-product-qty-evaluating', '1');
      try {
        placeMessages();
        var input = getQtyInput();
        if (!input) return;

        var vid = getCurrentVariantId();
        var pr = purchaseRules(vid);

        var q = parseInt(input.value, 10);
        if (!Number.isFinite(q) || q < 1) q = 1;

        var lastV = isCartLineRoot ? readCartLastValidQty() : NaN;
        var action = String(form.getAttribute('data-product-qty-last-action') || '');
        // Theme +/- moves by 1. After morph/cart refresh, memo can desync (e.g. 274 vs 250) and invert ceil/floor.
        if (isCartLineRoot && Number.isFinite(lastV) && Math.abs(q - lastV) > 1) {
          lastV = NaN;
          form.removeAttribute('data-product-qty-last-valid');
        }
        var next = snapQuantityCartDirected(q, pr.min, pr.inc, lastV, action);
        if (next !== q) applyQty(input, next);

        if (isCartLineRoot) {
          form.removeAttribute('data-product-qty-last-action');
          var inpFinal = getQtyInput();
          var fq = inpFinal ? parseInt(inpFinal.value, 10) : NaN;
          if (Number.isFinite(fq) && fq > 0) form.setAttribute('data-product-qty-last-valid', String(fq));
        } else {
          // Product page: clear action hint after using it for directed snapping.
          form.removeAttribute('data-product-qty-last-action');
        }

        vid = getCurrentVariantId();
        finishSyncAfterQty(input, vid, true);
      } finally {
        form.removeAttribute('data-product-qty-evaluating');
      }
    }

    function syncOnly() {
      if (form.getAttribute('data-product-qty-evaluating') === '1') return;
      if (isCartLineRoot) clearCartQtyDebounce();
      form.setAttribute('data-product-qty-evaluating', '1');
      try {
        placeMessages();
        var input = getQtyInput();
        if (!input) return;
        var vid = getCurrentVariantId();
        finishSyncAfterQty(input, vid, false);
        if (isCartLineRoot && input) {
          var pr0 = purchaseRules(vid);
          var qq = parseInt(input.value, 10);
          if (Number.isFinite(qq) && qq > 0 && isPurchaseQtyValid(qq, pr0.min, pr0.inc)) {
            form.setAttribute('data-product-qty-last-valid', String(qq));
          }
        }
      } finally {
        form.removeAttribute('data-product-qty-evaluating');
      }
    }

    function showQtyRuleError(pr, q) {
      var msgs = getMessageEls();
      var ruleEl = msgs.err;
      if (!ruleEl) return;
      ruleEl.hidden = false;
      if (pr.min > 0 && q < pr.min) {
        ruleEl.textContent = 'Minimum order is ' + String(pr.min) + ' units.';
      } else if (pr.min > 0 && pr.inc > 1) {
        ruleEl.textContent =
          'Order in multiples of ' + String(pr.inc) + ' starting at ' + String(pr.min) + '.';
      } else if (pr.inc > 1) {
        ruleEl.textContent = 'Order in multiples of ' + String(pr.inc) + ' units.';
      } else {
        ruleEl.textContent = 'Please adjust the quantity.';
      }
      ruleEl.scrollIntoView({ block: 'center' });
    }

    var qtyReevaluatePending = false;
    function scheduleQtyReevaluate() {
      if (isPdpQtyFieldFocused()) return;
      if (qtyReevaluatePending) return;
      qtyReevaluatePending = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          qtyReevaluatePending = false;
          evaluate();
        });
      });
    }

    function isPdpQtyFieldFocused() {
      if (isCartLineRoot) return false;
      var qIn = getQtyInput();
      if (!qIn) return false;
      var ae = document.activeElement;
      if (!ae) return false;
      if (ae === qIn) return true;
      try {
        if (qIn.contains && qIn.contains(ae)) return true;
      } catch (e1) {}
      var host =
        qIn.closest &&
        qIn.closest('quantity-selector[data-quantity-selector], quantity-selector[data-quantity-selector]');
      if (host && ae === host) return true;
      try {
        if (host && host.shadowRoot && host.shadowRoot.activeElement === qIn) return true;
      } catch (e2) {}
      return false;
    }

    function onFormEvent(ev) {
      if (form.getAttribute('data-product-qty-internal') === '1') return;
      if (form.getAttribute('data-product-qty-evaluating') === '1') return;
      var t = ev && ev.target;
      if (!isCartLineRoot && ev && ev.type === 'input') {
        var qIn0 = getQtyInput();
        if (qIn0) {
          if (t === qIn0) return;
          var qtyHost0 = qIn0.closest && qIn0.closest('[data-quantity-selector], quantity-selector');
          if (qtyHost0 && t === qtyHost0) return;
          if (typeof ev.composedPath === 'function') {
            try {
              var path0 = ev.composedPath();
              for (var ci = 0; ci < path0.length; ci++) {
                if (path0[ci] === qIn0) return;
              }
            } catch (e0) {}
          }
        }
      }
      var isLineQty =
        t &&
        t.matches &&
        (t.matches('input[name="quantity"][data-quantity-input]') ||
          (isCartLineRoot && t.matches('input[data-quantity-input]')));
      if (isLineQty) {
        if (isCartLineRoot) {
          if (ev.type === 'input') return;
          if (ev.type === 'change' || ev.type === 'blur') {
            clearCartQtyDebounce();
            evaluate();
          }
          return;
        }
        if (ev.type === 'input') {
          return;
        }
        if (ev.type === 'change' || ev.type === 'blur') {
          evaluate();
        }
        return;
      }
      if (!isCartLineRoot) evaluate();
    }

    function bindEasifyObserver() {
      var root = form.querySelector('.easify-product-options');
      if (!root || form.getAttribute('data-product-qty-easify-mo') === '1') return;
      form.setAttribute('data-product-qty-easify-mo', '1');
      var t = null;
      var mo = new MutationObserver(function () {
        if (t) clearTimeout(t);
        t = setTimeout(function () {
          t = null;
          if (form.getAttribute('data-product-qty-internal') === '1') return;
          if (isPdpQtyFieldFocused()) return;
          evaluate();
        }, 150);
      });
      mo.observe(root, { childList: true, subtree: true, attributes: true });
    }

    var run = function (ev) {
      onFormEvent(ev);
    };

    form.addEventListener('input', run, true);
    form.addEventListener('change', run, true);
    if (isCartLineRoot) {
      var cartQtyInput = getQtyInput();
      if (cartQtyInput) cartQtyInput.addEventListener('blur', run, true);
    } else {
      var pdpQtyInput = getQtyInput();
      if (pdpQtyInput) pdpQtyInput.addEventListener('blur', run, true);
    }

    var vs = form.querySelector('variant-selection[data-variant-selection]');
    if (vs) {
      vs.addEventListener(
        'variant-change',
        function (ev) {
          var d = ev && ev.detail && ev.detail.variant;
          var vid = d && d.id != null ? String(d.id) : getCurrentVariantId();
          publishFloorOnForm(purchaseRules(vid));
        },
        true
      );
      vs.addEventListener('variant-change', function () {
        run();
        requestAnimationFrame(run);
      });
    }

    var qtySel = form.querySelector('quantity-selector[data-quantity-selector], quantity-selector');
    if (qtySel) {
      qtySel.addEventListener('quantity:change', function () {
        if (isCartLineRoot) scheduleCartLineEvaluate();
        else scheduleQtyReevaluate();
      });
    }

    form.addEventListener(
      'click',
      function (ev) {
        var btn =
          ev.target &&
          ev.target.closest &&
          ev.target
            .closest('[data-quantity-minus], button[name="minus"], .quantity-selector__button--minus, button.quantity-selector__button--minus');
        if (!btn) return;
        if (!form.contains(btn)) return;
        var input = getQtyInput();
        if (!input) return;
        var vid = getCurrentVariantId();
        var pr = purchaseRules(vid);
        var q = readQty(input);
        if (pr.min > 0 && q === pr.min) {
          if (isCartLineRoot) clearCartQtyDebounce();
          ev.preventDefault();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
          ev.stopPropagation();
          showQtyRuleError(pr, q);
        }
      },
      true
    );

    form.addEventListener(
      'click',
      function (ev) {
        var btn =
          ev.target &&
          ev.target.closest &&
          ev.target.closest(
            '[data-quantity-plus], [data-quantity-minus], .quantity-selector__button--plus, .quantity-selector__button--minus, button.quantity-selector__button--plus, button.quantity-selector__button--minus'
          );
        if (!btn || !form.contains(btn) || !isCartLineRoot) return;

        var nm = String((btn.getAttribute && btn.getAttribute('name')) || btn.name || '').toLowerCase();
        var action = '';
        if (nm === 'plus' || (btn.classList && btn.classList.contains('quantity-selector__button--plus'))) action = 'inc';
        else if (nm === 'minus' || (btn.classList && btn.classList.contains('quantity-selector__button--minus'))) action = 'dec';
        if (!action) return;

        ev.preventDefault();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        ev.stopPropagation();
        handleCartQtyButton(btn, action);
      },
      true
    );

    form.addEventListener(
      'click',
      function (ev) {
        var btn =
          ev.target &&
          ev.target.closest &&
          ev.target.closest(
            '[data-quantity-plus], [data-quantity-minus], .quantity-selector__button--plus, .quantity-selector__button--minus, button.quantity-selector__button--plus, button.quantity-selector__button--minus'
          );
        if (!btn || !form.contains(btn)) return;
        var nm = String((btn.getAttribute && btn.getAttribute('name')) || btn.name || '').toLowerCase();
        if (nm === 'plus' || (btn.classList && btn.classList.contains('quantity-selector__button--plus'))) {
          form.setAttribute('data-product-qty-last-action', 'inc');
        } else if (nm === 'minus' || (btn.classList && btn.classList.contains('quantity-selector__button--minus'))) {
          form.setAttribute('data-product-qty-last-action', 'dec');
        }
        if (isCartLineRoot) scheduleCartLineEvaluate();
        else scheduleQtyReevaluate();
      },
      true
    );

    bindEasifyObserver();

    function validateSubmitForLine() {
      syncOnly();
      var input = getQtyInput();
      if (!input) return true;
      var vid = getCurrentVariantId();
      var pr = purchaseRules(vid);
      var q = parseInt(input.value, 10);
      if (!Number.isFinite(q) || q < 1) q = 1;
      if (!isPurchaseQtyValid(q, pr.min, pr.inc)) {
        showQtyRuleError(pr, q);
        return false;
      }
      return true;
    }

    if (!(form.matches && form.matches('div[data-product-qty-cart-line]'))) {
      form.addEventListener(
        'submit',
        function (e) {
          if (!validateSubmitForLine()) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    var atcBtn = form.querySelector('button[data-product-atc]');
    if (atcBtn) {
      atcBtn.addEventListener(
        'click',
        function (e) {
          syncOnly();
          var input = getQtyInput();
          if (!input) return;
          var vid = getCurrentVariantId();
          var pr = purchaseRules(vid);
          var q = parseInt(input.value, 10);
          if (!Number.isFinite(q) || q < 1) q = 1;

          if (!isPurchaseQtyValid(q, pr.min, pr.inc)) {
            e.preventDefault();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            e.stopPropagation();
            showQtyRuleError(pr, q);
            return;
          }
        },
        true
      );
    }

    productQtyHandlersByForm.set(form, {
      evaluate: evaluate,
      syncOnly: syncOnly,
      validateSubmit: validateSubmitForLine,
    });

    evaluate();

    // Cart lines can be hydrated by theme/app scripts after our first pass; re-snap shortly to avoid races.
    if (isCartLineRoot) {
      setTimeout(scheduleCartLineEvaluate, 0);
      setTimeout(scheduleCartLineEvaluate, 220);
    }
  }

  function requestClamp(form) {
    if (!form || form.getAttribute('data-product-qty-bound') !== '1') return;
    var h = productQtyHandlersByForm.get(form);
    if (h && typeof h.evaluate === 'function') h.evaluate();
  }

  function requestSyncOnly(form) {
    if (!form || form.getAttribute('data-product-qty-bound') !== '1') return;
    var h = productQtyHandlersByForm.get(form);
    if (h && typeof h.syncOnly === 'function') h.syncOnly();
  }

  document.addEventListener(
    'focusout',
    function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;

      if (
        t.matches &&
        (t.matches('input[name="quantity"][data-quantity-input]') ||
          t.matches('input[name^="updates"][data-quantity-input]'))
      ) {
        var rootClamp =
          t.closest('form[data-product-form]') || t.closest('div[data-product-qty-cart-line]');
        requestClamp(rootClamp);
        return;
      }

      var host =
        t.closest &&
        t.closest('quantity-selector[data-quantity-selector], quantity-selector[data-quantity-selector]');
      if (!host) return;
      var rt = ev.relatedTarget;
      if (rt && host.contains(rt)) return;
      var rootClamp2 =
        host.closest('form[data-product-form]') || host.closest('div[data-product-qty-cart-line]');
      requestClamp(rootClamp2);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (ev) {
      var btn = ev.target.closest && ev.target.closest('button[data-product-atc]');
      if (!btn) return;
      requestSyncOnly(btn.closest('form[data-product-form]'));
    },
    true
  );

  function startScan() {
    bindEasifyDelegatedDocumentChange();
    scanAndBind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startScan);
  } else {
    startScan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanAndBind(event.target);
  });
})();

/* Easify add-to-cart redirect bridge (minimal, theme-safe). */
(function () {
  if (window.__zocoEasifyRedirectBridgeInit) return;
  window.__zocoEasifyRedirectBridgeInit = true;

  var CART_ADD_RE = /\/cart\/add\.js(?:\?|$)/;
  var CART_RE = /\/cart\.js(?:\?|$)/;
  var SHOPIFY_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function cartUrl() {
    var root = SHOPIFY_ROOT && SHOPIFY_ROOT.slice(-1) === '/' ? SHOPIFY_ROOT : SHOPIFY_ROOT + '/';
    return root + 'cart';
  }

  function safeDispatchCartCountUpdate(cart) {
    try {
      window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
    } catch (e) {}
  }

  function redirectToCart() {
    window.location.assign(cartUrl());
  }

  function fetchCartAndUpdateCount() {
    try {
      return fetch(SHOPIFY_ROOT + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          if (!res || !res.ok) return null;
          return res.json();
        })
        .then(function (cart) {
          if (cart) safeDispatchCartCountUpdate(cart);
          return cart || null;
        })
        .catch(function () {
          return null;
        });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  var scheduled = false;
  function scheduleAfterSuccessfulAdd(cartMaybe) {
    if (scheduled) return;
    scheduled = true;

    setTimeout(function () {
      scheduled = false;

      if (cartMaybe) {
        safeDispatchCartCountUpdate(cartMaybe);
        redirectToCart();
        return;
      }

      fetchCartAndUpdateCount().then(function () {
        redirectToCart();
      });
    }, 0);
  }

  document.addEventListener('product-form:cart:update', function (e) {
    if (!e || !e.detail || !e.detail.cart) return;
    scheduleAfterSuccessfulAdd(e.detail.cart);
  });

  try {
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function patchedFetch(input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var method = (init && init.method) || (input && input.method) || 'GET';

        return origFetch
          .apply(this, arguments)
          .then(function (res) {
            try {
              if (
                method &&
                String(method).toUpperCase() === 'POST' &&
                CART_ADD_RE.test(String(url)) &&
                res &&
                res.ok
              ) {
                scheduleAfterSuccessfulAdd();
              }
            } catch (e) {}
            return res;
          });
      };
    }
  } catch (e) {}

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
      this.__zocoMethod = method;
      this.__zocoUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function patchedSend() {
      try {
        this.addEventListener('load', function () {
          try {
            var method = String(this.__zocoMethod || '').toUpperCase();
            var url = String(this.__zocoUrl || '');
            if (CART_RE.test(url)) return;
            if (method === 'POST' && CART_ADD_RE.test(url) && this.status >= 200 && this.status < 300) {
              scheduleAfterSuccessfulAdd();
            }
          } catch (e) {}
        });
      } catch (e) {}

      return origSend.apply(this, arguments);
    };
  } catch (e) {}
})();

(function () {
  if (window.__zocoSamiCartSyncInit) return;
  window.__zocoSamiCartSyncInit = true;

  function parseMoneyText(t) {
    var s = String(t == null ? '' : t)
      .replace(/\u00a0|\u202f/g, ' ')
      .trim();
    s = s.replace(/['\u2019]/g, '');
    var rep = 0;
    while (rep < 24 && /(\d)\s+(\d)/.test(s)) {
      s = s.replace(/(\d)\s+(\d)/g, '$1$2');
      rep++;
    }
    s = s.replace(/[^\d.,-]/g, '');
    if (!s || s === '-') return NaN;
    var neg = s.charAt(0) === '-';
    if (neg) s = s.slice(1);
    s = s.replace(/[^\d.,]/g, '');
    if (!s) return NaN;
    var lastComma = s.lastIndexOf(',');
    var lastDot = s.lastIndexOf('.');
    var intPart;
    var decPart = '';
    if (lastComma === -1 && lastDot === -1) {
      intPart = s;
    } else if (lastComma > lastDot) {
      var partsC = s.split(',');
      decPart = partsC.length ? partsC.pop() : '';
      intPart = partsC.join('');
      intPart = intPart.replace(/\./g, '');
      decPart = String(decPart || '').replace(/[^\d]/g, '');
    } else {
      var partsD = s.split('.');
      decPart = partsD.length ? partsD.pop() : '';
      intPart = partsD.join('');
      intPart = intPart.replace(/,/g, '');
      decPart = String(decPart || '').replace(/[^\d]/g, '');
    }
    intPart = String(intPart || '').replace(/[^\d]/g, '');
    if (!intPart && !decPart) return NaN;
    var n = parseFloat(intPart + (decPart ? '.' + decPart : ''));
    return Number.isFinite(n) ? (neg ? -n : n) : NaN;
  }


  function fmtCents(c) {
    c = Math.round(Number(c) || 0);
    if (!Number.isFinite(c)) c = 0;
    var sh = window.Shopify;
    var cur = sh && sh.currency;
    var activeCode = null;
    try {
      if (cur && (cur.active || cur.currency || cur.current)) {
        activeCode = String(cur.active || cur.currency || cur.current).trim().toUpperCase();
      }
    } catch (e1) {}
    var localeByCurrency = {
      PLN: 'pl-PL',
      EUR: 'de-DE',
      GBP: 'en-GB',
      USD: 'en-US',
      CAD: 'en-CA',
      AUD: 'en-AU',
      JPY: 'ja-JP',
      CHF: 'de-CH',
      SEK: 'sv-SE',
      NOK: 'nb-NO',
      DKK: 'da-DK',
      CZK: 'cs-CZ',
      HUF: 'hu-HU',
      RON: 'ro-RO',
      MXN: 'es-MX',
      BRL: 'pt-BR',
      INR: 'en-IN',
    };
    if (activeCode && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        var loc =
          localeByCurrency[activeCode] ||
          (document.documentElement && document.documentElement.lang
            ? String(document.documentElement.lang).trim()
            : undefined);
        return new Intl.NumberFormat(loc, { style: 'currency', currency: activeCode }).format(c / 100);
      } catch (e2) {}
    }
    if (sh && typeof sh.formatMoney === 'function') {
      try {
        var mf =
          (cur && (cur.money_format || (cur.currency_code_enabled && cur.money_with_currency_format))) ||
          sh.money_format;
        return mf ? sh.formatMoney(c, mf) : sh.formatMoney(c);
      } catch (e3) {}
    }
    return String(c / 100);
  }

  function plainFmt(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '');
    var t = (d.textContent || '').trim();
    return t || String(html).replace(/<[^>]+>/g, '').trim();
  }

  function resetUnit(shop, sami) {
    if (!shop || !sami) return;
    shop.removeAttribute('hidden');
    shop.removeAttribute('aria-hidden');
    sami.setAttribute('hidden', '');
    sami.setAttribute('aria-hidden', 'true');
    var a = sami.querySelector('[data-zoco-sami-unit-strikethrough]');
    var b = sami.querySelector('[data-zoco-sami-unit-current]');
    if (a) a.textContent = '';
    if (b) b.textContent = '';
  }

  function lineQty(row) {
    var inp = row.querySelector('[data-quantity-input]');
    if (inp && inp.value !== '') {
      var q = parseInt(inp.value, 10);
      if (q > 0) return q;
    }
    var fx = row.querySelector('.cart-item__quantity-fixed');
    if (fx) {
      var q2 = parseInt(String(fx.textContent || '').trim(), 10);
      if (q2 > 0) return q2;
    }
    return 0;
  }

  function syncSamiCart() {
    var rows = document.querySelectorAll('li.cart-item[data-cartitem]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var skipWholesaleCopy = row.getAttribute('data-zoco-has-automatic-line-discount') === 'true';

      var cp = row.querySelector('.cart-item--content-price');
      var label = cp && cp.querySelector('[data-sami-discount-label]');
      var list = cp && cp.querySelector('[data-sami-volume-discount]');
      var shop = cp && cp.querySelector('[data-zoco-shopify-unit-prices]');
      var sami = cp && cp.querySelector('[data-zoco-sami-unit-prices]');
      if (!label || !list) {
        if (shop && sami) resetUnit(shop, sami);
        continue;
      }

      var saleEl = cp.querySelector('.samitaWS-customized-price');
      var origEl = cp.querySelector('.samitaWS-customized-original-price');
      if (!saleEl) {
        var box = row.querySelector(
          '.cart-item__total [data-cartitem-total], .cart-item__total [data-zoco-setup-fee-line-total]'
        );
        if (box) {
          saleEl = box.querySelector('.samitaWS-customized-price');
          origEl = box.querySelector('.samitaWS-customized-original-price');
        }
      }

      if (!saleEl || !origEl) {
        label.textContent = '';
        list.setAttribute('hidden', '');
        resetUnit(shop, sami);
        continue;
      }

      var lo = parseMoneyText(origEl.textContent);
      var ls = parseMoneyText(saleEl.textContent);
      if (!(lo > 0 && ls < lo)) {
        label.textContent = '';
        list.setAttribute('hidden', '');
        resetUnit(shop, sami);
        continue;
      }

      var lineSaveCents = Math.round((lo - ls) * 100);
      var pct = Math.round(((lo - ls) / lo) * 100);
      var pctOk = pct > 0 && pct <= 100;
      var fromLineTotal = !cp.contains(saleEl);
      var qty = lineQty(row);

      if (fromLineTotal && !qty) {
        label.textContent = '';
        list.setAttribute('hidden', '');
        resetUnit(shop, sami);
        continue;
      }

      var labelSaveCents = fromLineTotal
        ? lineSaveCents
        : qty > 0
          ? Math.round(lineSaveCents * qty)
          : lineSaveCents;

      if (skipWholesaleCopy) {
        label.textContent = '';
        list.setAttribute('hidden', '');
      } else {
        label.textContent = '';
        var m = document.createElement('span');
        m.className = 'money';
        m.textContent = plainFmt(fmtCents(labelSaveCents));
        label.appendChild(document.createTextNode((pctOk ? pct + '% OFF: ' : '') + 'Wholesale ('));
        label.appendChild(document.createTextNode('-'));
        label.appendChild(m);
        label.appendChild(document.createTextNode(')'));
        list.removeAttribute('hidden');
      }

      if (!shop || !sami) continue;

      if (cp.contains(saleEl)) {
        resetUnit(shop, sami);
        continue;
      }

      if (!qty) {
        resetUnit(shop, sami);
        continue;
      }

      var uo = Math.round((lo / qty) * 100);
      var us = Math.round((ls / qty) * 100);
      if (!(uo > 0 && us < uo)) {
        resetUnit(shop, sami);
        continue;
      }

      var sto = sami.querySelector('[data-zoco-sami-unit-strikethrough]');
      var stc = sami.querySelector('[data-zoco-sami-unit-current]');
      if (!sto || !stc) continue;
      sto.textContent = plainFmt(fmtCents(uo));
      stc.textContent = plainFmt(fmtCents(us));
      shop.setAttribute('hidden', '');
      shop.setAttribute('aria-hidden', 'true');
      sami.removeAttribute('hidden');
      sami.setAttribute('aria-hidden', 'false');
    }
  }

  var debounceT = null;
  var mo = null;
  var moRoot = null;

  function debouncedSync() {
    if (debounceT) clearTimeout(debounceT);
    debounceT = setTimeout(function () {
      debounceT = null;
      syncSamiCart();
    }, 55);
  }

  function ensureCartListObserver() {
    var root = document.querySelector('ul[data-cart-item-list]');
    if (!root) return;
    if (moRoot === root) return;
    try {
      if (mo) mo.disconnect();
    } catch (e) {}
    moRoot = root;
    mo = new MutationObserver(debouncedSync);
    mo.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  function bumpSamiCart() {
    ensureCartListObserver();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncSamiCart();
        debouncedSync();
      });
    });
  }

  window.addEventListener('samitaWSRenderWholesaleCompleted', bumpSamiCart);
  document.addEventListener('product-form:cart:update', bumpSamiCart);
  window.addEventListener('cartcount:update', bumpSamiCart);
  bumpSamiCart();
})();
